import * as React from "react";

const SvgIcnAnalyze = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="currentColor"
                d="M19 4.5h-9a.5.5 0 00-.5.5v1.5H5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1.5H19a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5z"
            />
            <path fill="currentColor" d="M12 11h2v4h-2zM15 7h2v8h-2z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M10 4h9a1 1 0 011 1v12a1 1 0 01-1 1h-9a1 1 0 01-1-1V5a1 1 0 011-1zm0 13h9V5h-9v12z"
            />
        </g>
    </svg>
);

export default SvgIcnAnalyze;
